/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum CarouselDirectionEnum {
    RIGHT = 'RIGHT',
    LEFT = 'LEFT'
}
